import React, { Component } from "react"
import _ from "lodash"
import settings from "settings"
import { Pie, HorizontalBar, Bar, Line } from "react-chartjs-2"
import colorArray from "helpers/colorArray"
import moment from "moment"
import ReactTable from "react-table"
import percentChange from "helpers/percentChange"
import helpers from "helpers/helpers"
import numeral from "numeral"
import lineOptions from "helpers/lineOptions"
import StackedHorizontalBar from "components/StackedHorizontalBar"
import currentUser from "helpers/currentUser"
import Chart from "react-apexcharts"
import Switch from "react-switch"

const SalesAndConstruction = React.lazy(() => import("weeklyWidgets/SalesAndConstruction"))
const UnderContract = React.lazy(() => import("weeklyWidgets/UnderContract"))
const HomesClosedPTD = React.lazy(() => import("weeklyWidgets/HomesClosedPTD"))
const CompletedInventory = React.lazy(() => import("weeklyWidgets/CompletedInventory"))
const YoYStats = React.lazy(() => import("weeklyWidgets/YoYStats"))
const AveragePriceLotType = React.lazy(() => import("weeklyWidgets/AveragePriceLotType"))
const InventoryByBuilder = React.lazy(() => import("weeklyWidgets/InventoryByBuilder"))

let limit = 20

class WeeklyReportMethods {
	realtorPercent = (state, props) => {
		let count = 0
		let total = 0
		let percent = 0
		for (let v of state.sales) {
			if (settings?.noRealtorTracking?.includes(v.property)) {
				continue
			}
			if (v.transfer_date || v.cancel_date || (v.bustout_date && !settings.realtorGross)) {
				continue
			}
			if (v.realtor_involved === 1) {
				count++
			}
			total++
		}

		percent = count / total
		if (!isFinite(percent)) {
			percent = 0
		}

		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)
		return (
			<>
				<p className="mid" style={{ marginTop: 0 }}>
					Realtor Involved Sales: {count}/{total}
				</p>
				<div className="gauge">
					<Chart
						options={helpers.gaugeOptions("Realtor Sales %")}
						series={[percent]}
						type="radialBar"
						width={"100%"}
					/>
				</div>
			</>
		)
	}

	bustRate = (state, props) => {
		let percent = state.weeklyTotals.busts / state.weeklyTotals.gross
		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)
		return (
			<div className="gauge pt-4">
				<Chart
					options={helpers.gaugeOptions("Cancel Rate")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	ytdRealtorPercent = (state, props) => {
		if (state.allSales.length == 0) {
			return
		}
		let count = 0
		let total = 0
		let percent = 0
		for (let v of state.allSales) {
			if (settings.noRealtorTracking.includes(v.property) || (v.bustout_date && !settings.realtorGross)) {
				continue
			}
			let year = parseInt(moment.unix(v.sale_date).format("YYYY"))
			if (year !== state.times.year) {
				continue
			}
			if (state.active !== "week") {
				if (v.metro_group !== state.active) {
					continue
				}
			}
			if (v.realtor_involved === 1) {
				count++
			}
			total++
		}

		percent = count / total
		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)

		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Realtor Sales")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	ytdBustRate = (state, props) => {
		let sales = _.filter(state.allSales, (r) => {
			let year = parseInt(moment.unix(r.sale_date).format("YYYY"))
			if (year == state.times.year) {
				return true
			}
		})
		let busts = _.filter(state.allBusts, (r) => {
			let year = parseInt(moment.unix(r.bustout_date).format("YYYY"))
			if (year == state.times.year) {
				return true
			}
		})
		let percent = busts.length / sales.length

		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = parseFloat(percent)
		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Cancel Rate")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	quickStats = (state, props, gross, busts, closings, id) => {
		// Weekly based

		_.forEach(props.payload.manualSales, (v) => {
			if (v.property !== props.payload.weekly.id) {
				return
			}
			if (id !== "week") {
				return
			}
			if (v.week == state.times.curWeek && v.year == state.times.year) {
				gross += v.sales_production + v.sales_custom
				busts += v.busts_production + v.busts_custom
			}
		})
		let net = gross - busts

		return {
			gross,
			busts,
			closings,
			net,
		}
	}

	builderSalesAndLotType = (state, props) => {
		let dataArray = {}
		let model = {}
		let set = state.sales
		_.forEach(set, (v) => {
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			if (!builder) return
			let name = helpers.safeString(builder.name)
			if (!model.hasOwnProperty(name)) {
				model[name] = 0
			}
		})
		_.forEach(state.bustouts, (v) => {
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			if (!builder) return
			let name = helpers.safeString(builder.name)
			if (!model.hasOwnProperty(name)) {
				model[name] = 0
			}
		})
		_.forEach(set, (v) => {
			if (!v.builder || v.transfer_date) return
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			let name = helpers.safeString(builder.name)
			if (!type || !v.builder) return

			let path = `${type.name}.${name}`
			if (_.has(dataArray, path)) {
				dataArray[type.name][name]++
			} else {
				dataArray[type.name] = _.clone(model)
				dataArray[type.name][name]++
			}
		})
		_.forEach(state.bustouts, (v) => {
			if (!v.builder || v.cancel_date || v.transfer_date) {
				return
			}
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			let name = helpers.safeString(builder.name)
			if (!type || !v.builder) {
				return
			}
			let path = `${type.name}.${name}`
			if (_.has(dataArray, path)) {
				dataArray[type.name][name]--
			} else {
				dataArray[type.name] = _.clone(model)
				dataArray[type.name][name]--
			}
		})
		// Create series
		let series = []
		_.forEach(dataArray, (v, k) => {
			series.push({
				name: k,
				data: Object.values(v),
			})
		})
		series = _.sortBy(series, "name")
		//console.log(series, model)
		return <StackedHorizontalBar series={series} categories={Object.keys(model)} />
	}

	builderSales = (state, props) => {
		var [dataArray, labels, sorted, labelBuilders, dataSorted] = [{}, [], [], [], []]
		let set = state.sales
		_.forEach(set, (v) => {
			if (!v.builder) {
				return
			}
			let b = _.find(props.payload.public.builders, {
				id: parseInt(v.builder),
			})
			if (!b) {
				return
			}
			let name = b.name
			if (name in dataArray) {
				dataArray[name]++
			} else {
				dataArray[name] = 1
			}
		})
		_.forEach(state.bustouts, (v) => {
			if (!v.builder) {
				return
			}
			let b = _.find(props.payload.public.builders, {
				id: parseInt(v.builder),
			})
			let name = b.name
			if (name in dataArray) {
				dataArray[name]--
			} else {
				dataArray[name] = -1
			}
		})
		for (var prop in dataArray) {
			sorted.push([prop, dataArray[prop]])
		}

		_.forEach(sorted, (v) => {
			labelBuilders.push(v[0])
			dataSorted.push(v[1])
		})
		labels = Object.keys(dataArray)
		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)
		let colors = _.clone(colorArray)
		colors = helpers.builderSwapColors(colors, labels, props.payload.public.builders, "exact")
		const data = {
			labels: labels,
			datasets: [
				{
					data: _.values(dataSorted),
					backgroundColor: colors,
				},
			],
		}
		return <Pie data={data} options={opts} />
	}

	numberVisits = (state, props) => {
		//console.log(state, props)
		let statuses = state.weeklyTotals.numberVisits
		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: {
					formatter: (value, ctx) => {
						let datasets = ctx.chart.data.datasets
						if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
							let sum = datasets[0].data.reduce((a, b) => a + b, 0)
							let percentage = Math.round((value / sum) * 100) + "%"
							return percentage
						} else {
							return 1
						}
					},
					//color: "#fff",
				},
			},
		}

		return <Pie data={data} options={opts} />
	}

	trafficSources = (state, props) => {
		// Need to count traffic and sale sources, traffic should come in the payload
		var [labels, dataArray, sorted, f] = [[], {}, [], []]
		_.forEach(state.sales, (v) => {
			if (!v.traffic_source) {
				return
			}
			if (v.traffic_source in dataArray) {
				dataArray[v.traffic_source]++
			} else {
				dataArray[v.traffic_source] = 1
			}
		})
		_.forEach(props.payload.traffic.split, (v, k) => {
			if (k in dataArray) {
				dataArray[k] += v
			} else {
				dataArray[k] = v
			}
		})
		for (var source in dataArray) {
			sorted.push([source, dataArray[source]])
		}
		sorted
			.sort(function (a, b) {
				return a[1] - b[1]
			})
			.reverse()
		_.forEach(sorted, (v) => {
			if (v[0] !== "0") {
				f.push(v[1])
				let b = _.find(props.payload.public.trafficSources, {
					id: parseInt(v),
				})
				labels.push(`${b.name}`)
			}
		})
		labels = labels.slice(0, limit)
		f = f.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sold",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: f,
				},
			],
		}

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						stacked: true,
					},
				],
				yAxes: [
					{
						stacked: true,
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	floorplans = (state, props) => {
		var [labels, floorplans, sorted, labelFloorplans, dataSorted] = [[], [], [], [], []]
		_.forEach(state.sales, (v, k) => {
			if (!v.floorplan) {
				return
			}
			//var floorplanName = props.payload.floorplans[v.floorplan]
			if (v.floorplan in floorplans) {
				floorplans[v.floorplan]++
			} else {
				floorplans[v.floorplan] = 1
			}
		})
		for (var prop in floorplans) {
			sorted.push([prop, floorplans[prop]])
		}

		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse().slice(0, limit)
		_.forEach(sorted, (v) => {
			labelFloorplans.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelFloorplans, (v) => {
			v = parseInt(v)
			if (isNaN(v)) {
				return
			}
			let b = _.find(props.payload.public.floorplans, {
				id: parseInt(v),
			})
			if (b) {
				labels.push(`${b.name}`)
			}

			//labels.push(props.payload.public.floorplans[v])
		})
		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
		}

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						stacked: true,
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
				yAxes: [
					{
						stacked: true,
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	salesMeter = (state, props, type) => {
		let property = props.activeProperties ? props.activeProperties : props.payload.activeProperties[0]
		if (property && settings.salesMeterHideProperties && settings.salesMeterHideProperties.includes(property)) {
			return ""
		}
		let year = new Date().getFullYear()
		let projected = 0
		let total = 0
		let current = 0
		let previous = 0
		let set =
			type == "internal"
				? props.payload.exec.weeklyReport.communityPerformance
				: props.payload.communityPerformance
		_.forEach(set, (v, k) => {
			current += v.thisYearSales - v.thisYearBusts
			projected += v.current_projected
			previous += v.net_previous_year
			total += v.thisYearTotalProjected
		})
		let currentPercent = (current / total) * 100
		let currentWidth = currentPercent >= 100 ? 100 : currentPercent
		let projectedPercent = (projected / total) * 100
		let previousPercent = (previous / total) * 100

		projectedPercent = projectedPercent >= 100 ? 100 : projectedPercent
		previousPercent = previousPercent >= 100 ? 100 : previousPercent

		return (
			<div className="statBox__row hideMobile">
				<div className="statBox__box">
					<h3 className="statBox__title">
						<span className="bug">YTD</span>Home Sales Analysis
					</h3>
					<div className="meter__cont pt-8">
						<div className="meter">
							<div className="meter__fill" style={{ width: currentWidth + "%" }}>
								<span>
									{current.toLocaleString()} Net ({Math.round(currentPercent)}%)
								</span>
							</div>
							{!settings.disabled.projections && (
								<div className="meter__projected" style={{ left: projectedPercent + "%" }}>
									<span>
										{projected.toLocaleString()} Projected ({Math.round(projectedPercent)}%)
									</span>
								</div>
							)}
							<div className="meter__previous" style={{ left: previousPercent + "%" }}>
								<span>
									{previous.toLocaleString()} Previous Year ({Math.round(previousPercent)}%)
								</span>
							</div>
						</div>
						{!settings.disabled.projections && (
							<div className="meter__total">{total.toLocaleString()} Projected Annual Sales Goal</div>
						)}
					</div>
				</div>
			</div>
		)
	}

	cumulativeSales = (state, props) => {
		//? If projections are off on this, it's due to rounding.  We do month based projections, and at the end of the year all the rounding will throw the final numbers off.
		let years = [state.times.year - 1, state.times.year]
		let ret = {
			[state.times.year + " Actuals"]: [],
			[state.times.year - 1 + " Actuals"]: [],
		}
		let labels = []
		let currentWeek = moment().isoWeek()
		try {
			let bucket = props.payload.salesTotalsByWeek
			for (let i = 1; i <= 53; i++) {
				labels.push(i)
				//? Previous Year
				let lookup = bucket[years[0]][i]
				let last = _.last(ret[[state.times.year - 1 + " Actuals"]]) || 0
				let pusher = last
				if (lookup) {
					pusher += lookup.total
				}
				ret[[state.times.year - 1 + " Actuals"]].push(pusher)
				//? Current Year
				if (i < currentWeek) {
					lookup = bucket[years[1]][i]
					last = _.last(ret[[state.times.year + " Actuals"]]) || 0
					pusher = last
					if (lookup) {
						pusher += lookup.total
					}
					ret[[state.times.year + " Actuals"]].push(pusher)
				}
			}
			// The projections coming in are month based, so there's twelve.  Split each by 4 to get weekly
			if (!_.isEmpty(bucket["projected"])) {
				ret[state.times.year + " Projected"] = []
				let projections = []
				_.forEach(bucket["projected"], (v, k) => {
					let numWeeks = helpers.getIsoWeeksInMonth(moment().year(), k)
					for (let i = 1; i <= numWeeks; i++) {
						let last = _.last(projections) || 0
						projections.push(last + Math.round(v.total / numWeeks))
					}
				})
				ret[[state.times.year + " Projected"]] = projections
			}
		} catch (e) {
			console.error(e)
		}
		let weekEndData = helpers.calculateWeekEndDates(moment().year())
		let opts = {
			tooltips: {
				callbacks: {
					title: function (tooltipItem, data) {
						return `Week: ${parseInt(tooltipItem[0].xLabel).toLocaleString()}`
					},
					label: function (tooltipItem, data) {
						let label = ""
						try {
							label = `Week ending: ${weekEndData[tooltipItem.label].weekEndDate}`
						} catch (e) {
							console.log(e)
						}

						return label
					},
				},
			},
			legend: {
				display: true,
				position: "bottom",
			},
			scales: {
				xAxes: [
					{
						ticks: {
							//beginAtZero: true,
							autoSkip: false,
						},
					},
				],
			},
			plugins: {
				datalabels: state.cumulativeShowLabels.display
					? { clamp: true, anchor: "end", align: "end", offset: 5 }
					: false,
			},
		}
		const data = {
			labels: labels,
			datasets: [
				{
					label: [state.times.year + " Actuals"],
					data: ret[[state.times.year + " Actuals"]],
					borderColor: "#5A9BD4",
					backgroundColor: "#5A9BD4",
					fill: false,
				},
				{
					label: [state.times.year - 1 + " Actuals"],
					data: ret[[state.times.year - 1 + " Actuals"]],
					borderColor: "#F57A27",
					backgroundColor: "#F57A27",
					fill: false,
				},
			],
		}
		if (!_.isEmpty(ret[[state.times.year + " Projected"]])) {
			data.datasets.push({
				label: [state.times.year + " Projected"],
				data: ret[[state.times.year + " Projected"]],
				borderColor: "#FFD700",
				backgroundColor: "#FFD700",
				fill: false,
				datalabels: {
					//display: false,
				},
			})
		}
		//
		return (
			<div className="mt-2">
				<div className="flex justify-end items-center" data-html2canvas-ignore="true">
					<Switch
						onChange={() => {
							state.cumulativeShowLabels.flip()
						}}
						checked={state.cumulativeShowLabels.display}
						checkedIcon={false}
						uncheckedIcon={false}
						height={20}
						width={40}
						key={"switch-cumulative"}
						id={"switch"}
					/>
					<p className="!text-xs !ml-2 text-blue font-bold">Show Labels</p>
				</div>
				<Line data={data} options={opts} />
			</div>
		)
	}

	salesList = (state, props) => {
		let columns = [
			{
				Header: "Sales Person",
				accessor: "salesperson",
			},
			{
				Header: "Builder",
				accessor: "builder",
			},
			{
				Header: "Address",
				accessor: "address",
			},
			{
				Header: "Price",
				accessor: "price",
				Cell: (v) => {
					if (v.value) {
						return `$${v.value.toLocaleString()}`
					}
					return ""
				},
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
			},
		]

		var ret = []

		for (let r of state.sales) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}

			v.salesperson = salesperson
			v.address = r.address
			v.price = r.price
			v.builder = builder
			v.date = r.sale_date ? r.sale_date : r.addedDate

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return <ReactTable loadingText="" data={ret} columns={columns} defaultPageSize={10} />
	}

	bustoutList = (state, props) => {
		let columns = [
			{
				Header: "Sales Person",
				accessor: "salesperson",
			},
			{
				Header: "Builder",
				accessor: "builder",
			},
			{
				Header: "Address",
				accessor: "address",
			},
			{
				Header: "Price",
				accessor: "price",
				Cell: (v) => `$${v.value.toLocaleString()}`,
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
			},
		]

		var ret = []

		for (let r of state.bustouts) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}

			v.salesperson = salesperson
			v.address = r.address
			v.builder = builder
			v.price = r.price
			v.date = r.sale_date ? r.sale_date : r.addedDate

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return <ReactTable loadingText="" data={ret} columns={columns} defaultPageSize={10} />
	}

	closingList = (state, props) => {
		let columns = [
			{
				Header: "Sales Person",
				accessor: "salesperson",
			},
			{
				Header: "Builder",
				accessor: "builder",
			},
			{
				Header: "Address",
				accessor: "address",
			},
			{
				Header: "Price",
				accessor: "price",
				Cell: (v) => `$${v.value.toLocaleString()}`,
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
			},
		]

		var ret = []

		for (let r of state.closings) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}

			v.salesperson = salesperson
			v.address = r.address
			v.builder = builder
			v.price = r.price
			v.date = r.sale_date ? r.sale_date : r.addedDate

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return <ReactTable loadingText="" data={ret} columns={columns} defaultPageSize={10} />
	}

	salesTD = (state, props) => {
		// Last 2 years
		let year = new Date().getFullYear()
		let years = [year - 1, year]
		let projection = 0
		let ret = {}
		// Only this year's projections
		_.forEach(props.payload.communityPerformance, (v, k) => {
			if (state.active !== "week" && v.metro_group !== state.active) {
				return
			}

			projection += v.current_projected
		})
		if (state.active !== "week") {
			let current = 0
			let projected = 0
			let previous = 0
			_.forEach(props.payload.communityPerformance, (v, k) => {
				if (v.metro_group !== state.active) {
					return
				}

				current += v.thisYearSales - v.thisYearBusts
				projected += v.current_projected
				previous += v.net_previous_year
			})
			ret = {
				"Previous YTD": previous,
				"Actual YTD": current,
				"Projected YTD": projected,
			}
		} else {
			ret = {
				"Previous YTD": props.payload.ytdTotals.lastYearSales - props.payload.ytdTotals.lastYearBusts,
				"Actual YTD": props.payload.ytdTotals.thisYearSales - props.payload.ytdTotals.thisYearBusts,
				"Projected YTD": projection,
			}
		}
		let percents = {
			avp: Math.round(percentChange(ret["Projected YTD"], ret["Actual YTD"])), // actual vs projected
			pvc: Math.round(percentChange(ret["Previous YTD"], ret["Actual YTD"])), // previous vs current
		}
		_.forEach(percents, (v, k) => {
			if (Math.sign(v) == 1) {
				percents[k] = <span className="darkGreen bold">{`+${v}%`}</span>
			} else if (Math.sign(v) == -1) {
				percents[k] = <span className="red bold">{`${v}%`}</span>
			}
		})
		let sorted = []
		let labels = []
		_.forEach(ret, (v, k) => {
			labels.push(k)
			sorted.push(v)
		})

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
			},
		}

		const data = {
			labels: labels,
			datasets: [
				{
					label: "NET Sales",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: sorted,
				},
			],
		}
		return (
			<>
				<HorizontalBar data={data} options={opts} />
				<p style={{ textAlign: "center", fontSize: "14px" }}>
					Actual vs. Previous YTD: {percents.pvc} | Actual vs. Projected YTD: {percents.avp}
				</p>
			</>
		)
	}

	communityPerformance = (state, props) => {
		let columns = [
			{
				Header: "Community",
				accessor: "community",
			},
			{
				Header: "Weekly",
				columns: [
					{
						Header: "Gross Sales",
						accessor: "gross_sales",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.gross_sales
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Net Sales",
						accessor: "net_sales",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.net_sales
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Cancellation Rate",
						accessor: "bust_rate",
						Cell: (v) => {
							/* if (v.value) {
								return `${v.value}%`
							} else if (v.value == 0) {
								return "0%"
							}
							return "" */
							if (v.value) {
								if (Math.sign(v.value) == 1) {
									return `${v.value}%`
								} else if (Math.sign(v.value) == -1) {
									return `-${v.value}%`
								}
							}
							return "0%"
						},
						Footer: (props) => {
							let percent = state.weeklyTotals.busts / state.weeklyTotals.gross
							percent = percent.toFixed(2)
							percent = parseFloat(percent)
							percent = Math.round(percent * 100)
							return percent + "%"
						},
					},
					{
						Header: "Average Sale Price",
						accessor: "avg_price",
						Cell: (v) => {
							if (v.value) {
								return `$${v.value.toLocaleString()}`
							}
							return "N/A"
						},
					},
				],
			},
			{
				Header: "",
				className: "ReactTable__gutter",
				maxWidth: 10,
				sortable: false,
			},
			{
				Header: "Year to Date NET",
				columns: [
					{
						Header: "Previous Year",
						accessor: "previous_year",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.previous_year
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Projected YTD",
						accessor: "projected",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.projected
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Actual YTD",
						accessor: "actual",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.actual
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Actual/Projected Variance",
						accessor: "variance",
						Cell: (v) => {
							if (v.value) {
								if (Math.sign(v.value) == 1) {
									return (
										<span className="darkGreen bold">
											+{v.value} / {v.original.avp}
										</span>
									)
								} else if (Math.sign(v.value) == -1) {
									return (
										<span className="red bold">
											{v.value} / {v.original.avp}
										</span>
									)
								}
							}
							return "0 / 0%"
						},
						Footer: (props) => {
							let actual = props.payload.ytdTotals.thisYearSales - props.payload.ytdTotals.thisYearBusts
							let projected = props.payload.ytdTotals.thisYearProjected
							let total = actual - projected
							let percent = Math.round(percentChange(projected, actual))
							if (Math.sign(total) == 1) {
								return (
									<span className="darkGreen bold">
										+{total} / +{percent}%
									</span>
								)
							} else if (Math.sign(total) == -1) {
								return (
									<span className="red bold">
										{total} / {percent}%
									</span>
								)
							} else {
								return 0
							}
						},
					},
					{
						Header: "YoY Variance",
						accessor: "yoy_variance",
						Cell: (v) => {
							if (Math.sign(v.value) == 1) {
								return (
									<span className="darkGreen bold">
										+{v.value} / {v.original.pvc}
									</span>
								)
							} else if (Math.sign(v.value) == -1) {
								return (
									<span className="red bold">
										{v.value} / {v.original.pvc}
									</span>
								)
							}
							return "0 / 0%"
						},
						Footer: (props) => {
							let thisYear = props.payload.ytdTotals.thisYearSales - props.payload.ytdTotals.thisYearBusts
							let lastYear = props.payload.ytdTotals.lastYearSales - props.payload.ytdTotals.lastYearBusts
							let total = thisYear - lastYear
							let percent = Math.round(percentChange(lastYear, thisYear))
							if (Math.sign(total) == 1) {
								return (
									<span className="darkGreen bold">
										+{total} / +{percent}%
									</span>
								)
							} else if (Math.sign(total) == -1) {
								return (
									<span className="red bold">
										-{total} / {percent}%
									</span>
								)
							} else {
								return 0
							}
						},
					},
				],
			},
		]

		var ret = []
		let count = 0
		_.forEach(props.payload.communityPerformance, (r, k) => {
			k = parseInt(k)
			if (state.active !== "week") {
				if (r.metro_group !== state.active) {
					return
				}
			}
			let v = {}

			let property = _.find(props.payload.public.properties, { id: k })
			if (!property) {
				return
			}
			if (property && property.in_weekly_report === 0) {
				return
			}
			v.community = property.name
			v.gross_sales = r.weekly_gross
			v.net_sales = r.weekly_net
			v.bust_rate = r.weekly_bust_rate
			v.variance = r.variance
			v.yoy_variance = r.yoy_variance
			v.previous_year = r.net_previous_year
			v.actual = r.net_current_actual
			v.projected = r.current_projected
			v.avg_price = r.avg_price
			v.avp = Math.round(percentChange(v.projected, v.actual))
			v.pvc = Math.round(percentChange(v.previous_year, v.actual))
			if (isNaN(v.avp) || !isFinite(v.avp)) {
				v.avp = 0
			}
			if (isNaN(v.pvc) || !isFinite(v.pvc)) {
				v.pvc = 0
			}
			if (Math.sign(v.avp) === 1) {
				v.avp = <span className="darkGreen bold">{`+${v.avp}%`}</span>
			} else if (Math.sign(v.avp) === -1) {
				v.avp = <span className="red bold">{`${v.avp}%`}</span>
			} else {
				v.avp = `0%`
			}

			if (Math.sign(v.pvc) === 1) {
				v.pvc = <span className="darkGreen bold">{`+${v.pvc}%`}</span>
			} else if (Math.sign(v.pvc) === -1) {
				v.pvc = <span className="red bold">{`${v.pvc}%`}</span>
			} else {
				v.pvc = `0%`
			}
			ret.push(v)
			count++
		})
		//ret = _.sortBy(ret, "date").reverse()
		return (
			<>
				<ReactTable
					data={ret}
					loadingText=""
					columns={columns}
					defaultPageSize={count}
					defaultSorted={[
						{
							id: "gross_sales",
							desc: true,
						},
					]}
				/>
			</>
		)
	}

	salesVariance = (state, props, reportType) => {
		let property = reportType == "internal" ? props.activeProperties[0] : props.payload.activeProperties[0]
		let ret = {
			"Previous Year": [],
			"Projected WTD": [],
			"Gross WTD": [],
			"Net WTD": [],
		}
		// Build buckets of lot types
		let labels = []
		let model = {
			previous: 0,
			projected: 0,
			thisGross: 0,
			thisNet: 0,
			thisCans: 0,
			lastGross: 0,
			lastCans: 0,
		}
		let lotTypes = _.filter(props.payload.public.lot_types, (v) => {
			return v.property == property
		})
		let b = {}
		_.forEach(lotTypes, (v) => {
			//labels.push(v.name)
			b[v.name] = _.clone(model)
		})
		_.forEach(state.sales, (v) => {
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			if (!type || !b[type.name]) return
			b[type.name].thisGross++
		})

		_.forEach(state.bustouts, (v) => {
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			if (!type || !b[type.name]) return
			b[type.name].thisCans++
		})

		_.forEach(state.lastYearSales, (v) => {
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			if (!type || !b[type.name]) return
			b[type.name].lastGross++
		})
		_.forEach(state.lastYearCancels, (v) => {
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			if (!type || !b[type.name]) return
			b[type.name].lastCans++
		})

		_.forEach(state.projections, (v) => {
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			if (!type || !b[type.name]) return
			if (v.month == state.times.curMonth) {
				b[type.name].projected += v.projection / 4
			} else {
				b[type.name].projected += v.projection
			}
		})
		// Remove any lot types that are all zeroes
		_.forEach(b, (v, k) => {
			let hasData = false
			_.forEach(v, (r) => {
				if (r > 0) {
					hasData = true
				}
			})
			if (!hasData) {
				delete b[k]
			}
		})
		// Create labels
		labels = Object.keys(b)
		_.forEach(labels, (v, k) => {
			let data = b[v]
			ret["Previous Year"].push(data.lastGross - data.lastCans)
			ret["Projected WTD"].push(data.projected)
			ret["Gross WTD"].push(data.thisGross)
			ret["Net WTD"].push(data.thisGross - data.thisCans)
		})
		let sorted = helpers.orderByLotType(labels, []) // this is just to order the labels
		// This goes through all the data and sorts, then reapplies that order to ret
		_.forEach(ret, (v, k) => {
			let sorted = helpers.orderByLotType(labels, v)
			ret[k] = sorted.data
		})
		let opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
				yAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
			},
		}
		const data = {
			labels: sorted.labels,
			datasets: [
				{
					label: "Previous Year Net Week " + state.selectedWeek,
					backgroundColor: "#C297F5",
					type: "line",
					fill: false,
					pointRadius: 10,
					pointHoverRadius: 10,
					borderColor: "#8f6fb5",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: ret["Previous Year"],
					hidden: state.active == "life" ? true : false,
				},
				{
					label: "Projected Week " + state.selectedWeek,
					backgroundColor: "#3295EC",
					borderColor: "#3295EC",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: ret["Projected WTD"],
					hidden: state.active == "life" || settings.disabled.projections ? true : false,
				},
				{
					label: state.active == "life" ? "Gross Sales" : "Gross Week " + state.selectedWeek,
					backgroundColor: "#ace07e",
					borderColor: "#ace07e",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: ret["Gross WTD"],
				},
				{
					label: state.active == "life" ? "Net Sales" : "Net Week " + state.selectedWeek,
					backgroundColor: "#ea7dd7",
					borderColor: "#ea7dd7",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: ret["Net WTD"],
				},
			],
		}
		//
		return <Bar data={data} options={opts} />
	}

	trafficBuilderLotType = (state, props, reportType) => {
		try {
			let store = {}
			if (state.active == "life") return ""
			let bucket = state.island ? props.payload.traffic : props.payload.exec.weeklyReport.trafficEntries.ytd
			let grouped = _.filter(
				state.island ? bucket.current.grouped.array : bucket.grouped,
				(r) => r.traffic_date >= moment().startOf("year").unix() && r.traffic_date <= state.endWeek
			)
			let indiv = _.filter(
				state.island ? bucket.current.entries : bucket.individual,
				(r) => r.traffic_date >= moment().startOf("year").unix() && r.traffic_date <= state.endWeek
			)
			_.forEach(grouped, (v) => {
				if (state.active === "week") {
					if (v.traffic_date < state.times.startWeek || v.traffic_date > state.times.endWeek) {
						return
					}
				} else if (state.active === "ytd" || state.active === "year") {
					if (
						v.traffic_date < state.times.thisYear ||
						v.traffic_date > moment.unix(state.times.thisYear).endOf("year").unix()
					)
						return
				} else {
					return
				}
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let lotType = _.find(props.payload.public.lot_types, { id: v.lot_type })
				if (!builder || !lotType) {
					builder = {
						name: "Welcome Center",
					}
					lotType = {
						name: "",
					}
				}
				let bname = helpers.safeBuilderName(builder.name)
				let path = `${bname}${lotType.name ? ` - ${lotType.name}` : ``}`
				if (!_.has(store, path)) {
					store[path] = 0
				}
				store[path] += v.prospect_count + v.realtor_count
			})
			_.forEach(indiv, (v) => {
				if (state.active === "week") {
					if (v.traffic_date < state.times.startWeek || v.traffic_date > state.times.endWeek) return
				} else if (state.active === "ytd" || state.active === "year") {
					if (
						v.traffic_date < state.times.thisYear ||
						v.traffic_date > moment.unix(state.times.thisYear).endOf("year").unix()
					)
						return
				} else {
					return
				}
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let lotType = _.find(props.payload.public.lot_types, { id: v.lot_type })
				if (!builder || !lotType) {
					builder = {
						name: "Welcome Center",
					}
					lotType = {
						name: "",
					}
				}
				let bname = helpers.safeBuilderName(builder.name)
				let path = `${bname}${lotType.name ? ` - ${lotType.name}` : ``}`
				if (!_.has(store, path)) {
					store[path] = 0
				}
				store[path]++
			})
			let exp = []
			_.forEach(store, (v, k) => {
				let e = k.split(" - ")
				let lt = e[1]
				if (parseInt(lt)) lt = parseInt(lt)
				// Check and see if this builder/lottype already exists
				if (_.find(exp, { builder: e[0], lot_type: lt })) {
					let f = _.find(exp, { builder: e[0], lot_type: lt })
					f.count += v
				} else exp.push({ builder: e[0], lot_type: lt, count: v })
			})
			exp = _.sortBy(exp, ["lot_type", "builder"])
			// Put it back
			store = {}
			_.forEach(exp, (v) => {
				let name = `${v.builder} - ${v.lot_type}`
				if (!v.lot_type) name = v.builder
				store[name] = v.count
			})
			let options = {
				chart: {
					type: "bar",
					//height: 350,
					toolbar: {
						show: true,
						tools: {
							download: false,
						},
					},
				},
				plotOptions: {
					bar: {
						horizontal: true,
					},
				},
				stroke: {
					width: 1,
					colors: ["#fff"],
				},
				xaxis: {
					categories: Object.keys(store),
				},
				colors: colorArray,
				fill: {
					opacity: 1,
				},
				legend: {
					position: "top",
					horizontalAlign: "left",
					offsetX: 40,
				},
				dataLabels: {
					enabled: true,
					style: {
						colors: ["#222"],
					},
				},
			}
			let series = [
				{
					name: "Traffic Count",
					data: Object.values(store),
				},
			]
			return <Chart options={options} series={series} type="bar" />
		} catch (e) {
			console.log(e)
		}
	}

	salesBySalespeople = (state, props) => {
		var [dataArray, labels, sorted, labelSalespeople, dataSorted] = [{}, [], [], [], []]
		let set
		if (state.active == "week") {
			set = props.payload.sales.current
		} else {
			set = props.payload.sales.allSales
		}
		set = state.sales
		_.forEach(set, (v) => {
			if (!v.salesperson) {
				return
			}
			if (v.salesperson in dataArray) {
				dataArray[v.salesperson]++
			} else {
				dataArray[v.salesperson] = 1
			}
		})

		_.forEach(state.bustouts, (v) => {
			if (!v.salesperson) {
				return
			}
			if (v.salesperson in dataArray) {
				dataArray[v.salesperson]--
			} else {
				dataArray[v.salesperson] = -1
			}
		})
		for (var prop in dataArray) {
			sorted.push([prop, dataArray[prop]])
		}
		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse()
		_.forEach(sorted, (v) => {
			labelSalespeople.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelSalespeople, (v) => {
			let sp = _.find(props.payload.public.salespeople, {
				id: parseInt(v),
			})
			if (!sp) return
			let builder = _.find(props.payload.public.builders, {
				id: sp.builders[0],
			})
			if (sp && builder) {
				labels.push(`${sp.first} ${sp.last} - ${builder.name}`)
			}
		})
		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
			},
		}
		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales ",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
		}

		return <HorizontalBar data={data} options={opts} />
	}

	weeklyDevExtraCalcs = (r) => {
		// This takes isDev and the devOnly flag into account.  If a user is not a dev user and the row has devOnly = true, then it will not add.
		let v = {}
		let user = currentUser()
		let isDev = user?.group == 1 ? true : false
		if (settings.weeklyDevUserVisibility) {
			let s = settings.weeklyDevUserVisibility
			_.forEach(s, (row, k) => {
				if (!isDev && row.devOnly) return
				if (row.id === "sqft") v.sqft = r.sqft
				if (row.id === "price") v.price = r.price
				if (row.id === "sale_date") v.sale_date = r.sale_date
				if (row.id === "builderVRealtor") v.builderVRealtor = r.realtor_involved ? "Realtor" : "Builder"
				if (row.id === "dirtVSpec") {
					if (!r.start_date) v.dirtVSpec = "Dirt"
					else {
						v.dirtVSpec = r.start_date < r.sale_date ? "Spec" : "Dirt"
					}
				}
				if (row.id === "ppsqft") v.ppsqft = r.price && r.sqft ? r.price / r.sqft : null
			})
		}
		return v
	}

	buildSalesTable = (state, props, useInput = false) => {
		var ret = []
		let set = state.sales
		if (useInput) set = state.salesInput
		for (let r of set) {
			if (r.transfer_date) {
				continue
			}
			var v = {}
			let lot = _.find(props.payload.exec.lots, { id: r.lot_id })
			let builder = ""
			let findBuilder = _.find(props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}
			let type
			let typeFind = _.find(props.payload.public.lot_types, { id: r.lot_type })
			if (typeFind) {
				type = typeFind.name
			}
			let section
			let sectionFind = _.find(props.payload.public.sections, { id: r.section_id })
			if (sectionFind) {
				section = sectionFind.name
			}
			let floorplan = _.find(props.payload.public.floorplans, { id: lot?.floorplan })
			let sale_type = "Dirt"
			if (r.sale_date && r.start_date && r.sale_date >= r.start_date) sale_type = "Spec"
			v.address = r.address
			v.builder = builder
			v.sale_date = r.sale_date
			v.lot_type = type
			v.section = section
			v.sqft = r.sqft
			v.beds = lot?.beds || ""
			v.floorplan = floorplan?.name || ""
			v.sale_type = sale_type
			let weeklys = this.weeklyDevExtraCalcs(r)
			if (settings.weeklyDevUserVisibility) v = { ...v, ...weeklys }

			ret.push(v)
		}
		ret = _.sortBy(ret, "date").reverse()
		return ret
	}

	buildCancelsTable = (state, props) => {
		var ret = []
		let set = state.bustouts
		for (let r of set) {
			var v = {}
			let builder = ""
			let findBuilder = _.find(props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}
			let type
			let typeFind = _.find(props.payload.public.lot_types, { id: r.lot_type })
			if (typeFind) {
				type = typeFind.name
			}
			let section
			let sectionFind = _.find(props.payload.public.sections, { id: r.section_id })
			if (sectionFind) {
				section = sectionFind.name
			}

			v.address = r.address
			v.builder = builder
			v.date = r.sale_date ? r.sale_date : r.addedDate
			v.lot_type = type
			v.section = section
			v.reason = r.bustout_reason
			v.cancel_date = r.bustout_date

			let weeklys = this.weeklyDevExtraCalcs(r)
			if (settings.weeklyDevUserVisibility) v = { ...v, ...weeklys }

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return ret
	}

	ytdAnalysis = (state, props) => {
		try {
			//? the averages are considered actual on this report.  we never loop through busts.
			let final = {
				html: null,
				data: [],
			}
			let ret = []
			let propertyID = state.island ? props.payload.activeProperties[0] : props.activeProperties[0]

			const echoHeader = (name) => {
				return (
					<thead key={`${name}echoheader`}>
						<tr className="">
							<th className="w-[15%] text-left py-2 border-b-[1px] border-b-gray-300">{name}</th>
							<th className="w-[10%] text-left py-2  border-b-[1px] border-b-gray-300">Gross Sales</th>
							<th className="w-[10%] text-left py-2  border-b-[1px] border-b-gray-300">Cancels</th>
							<th className="w-[10%] text-left py-2  border-b-[1px] border-b-gray-300">Net Sales</th>
							<th className="w-[20%] text-left py-2  border-b-[1px] border-b-gray-300">Avg Price</th>
							<th className="w-[15%] text-left py-2  border-b-[1px] border-b-gray-300">Avg Sqft</th>
							<th className="w-[20%] text-left py-2  border-b-[1px] border-b-gray-300">Avg PPSQFT</th>
						</tr>
					</thead>
				)
			}

			const echoRow = (vals) => {
				return (
					<tr key={`${vals.builder}${vals.net}-echoRow`}>
						<td className="py-1">{vals.builder}</td>
						<td className="py-1">{vals.bs}</td>
						<td className="py-1">{vals.bc}</td>
						<td className="py-1">{vals.net}</td>
						<td className="py-1">{numeral(vals.avgPrice).format("$0,0")}</td>
						<td className="py-1">{numeral(vals.avgSqft).format("0,0")}</td>
						<td className="py-1">{numeral(vals.avgPPSQFT).format("$0,0")}</td>
					</tr>
				)
			}

			const echoTypeTotal = (vals) => {
				return (
					<tr className="font-bold" key={`${vals.sales}${vals.cancels}-echoTypeTotal`}>
						<td className="pt-3"></td>
						<td className="pt-3">{vals.sales}</td>
						<td className="pt-3">{vals.cancels}</td>
						<td className="pt-3">{vals.sales - vals.cancels}</td>
						<td className="pt-3">{numeral(vals.avgPrice).format("$0,0")}</td>
						<td className="pt-3">{numeral(vals.avgSqft).format("0,0")}</td>
						<td className="pt-3">{numeral(vals.avgPPSQFT).format("$0,0")}</td>
					</tr>
				)
			}
			let types = _.filter(props.payload.public.lot_types, (v) => v.property == propertyID)
			let groups = _.filter(props.payload.public.lot_type_groups, (v) => v.property == propertyID)
			types = _.sortBy(types, "sizeNumber")
			let totalCount = 0 // sales with a price
			let totalCancels = 0
			// These remove cancels - so actuals
			let totalActualCount = 0
			let totalActualPrice = 0
			let totalActualSqft = 0
			let totalActualSqftCount = 0
			let groupStore = {} // this is for storage of lot types that are in groups
			let groupTypeStore = {} // this is the storage for the group type totals
			let groupDataStore = []
			_.forEach(types, (type) => {
				let groupFind = _.find(groups, (v) => v.children && v.children.includes(type.id))
				// For this lot type, totals
				let groupPrice = 0
				let groupSales = 0
				let groupSqft = 0
				let groupSqftCount = 0
				let header = echoHeader(type.marketing_name)

				let hasData = false
				let dataBox = []
				let typeSales = _.filter(state.sales, (v) => v.lot_type == type.id)
				let typeCancels = _.filter(state.bustouts, (v) => v.lot_type == type.id)
				totalCancels += typeCancels.length
				let builders = _.uniqBy(typeSales, (v) => v.builder)
				let cancelBuilders = _.uniqBy(typeCancels, (v) => v.builder)
				let merged = [...builders, ...cancelBuilders]
				builders = _.uniqBy(merged, (v) => v.builder)
				builders = _.map(builders, (v) => v.builder)
				// now we have an array of builder ids, need to sort them by name
				let builderNames = []
				_.forEach(builders, (v) => {
					let lookup = _.find(props.payload.public.builders, { id: v })
					if (lookup) builderNames.push({ id: v, name: lookup.name })
				})
				builderNames = _.sortBy(builderNames, "name")
				builders = _.map(builderNames, (r) => r.id)
				_.forEach(builders, (builderID) => {
					let builder = _.find(props.payload.public.builders, { id: builderID })
					if (!builder) {
						console.log(`Cannot find builder: ${builderID}`)
						return
					}
					let bs = _.filter(typeSales, (v) => v.builder === builderID)
					let bc = _.filter(typeCancels, (v) => v.builder === builderID)
					if (bs.length > 0 || bc.length > 0) hasData = true
					if (!hasData) return
					let net = bs.length - bc.length
					let grossPrice = 0
					let grossSales = 0
					let grossSqft = 0
					let grossSqftCount = 0
					_.forEach(bs, (v) => {
						if (v.price) {
							if (!v.bustout_date) {
								grossPrice += v.price
								grossSales++
								groupPrice += v.price
								groupSales++
								totalActualCount++
								totalActualPrice += v.price
							}
							totalCount++
						} else {
							console.error("Found a sale without a price. Sale ID: ", v.id)
						}
						if (v.sqft) {
							if (!v.bustout_date) {
								grossSqft += v.sqft
								grossSqftCount++
								groupSqft += v.sqft
								groupSqftCount++
								totalActualSqft += v.sqft
								totalActualSqftCount++
							}
						} else {
							console.log("Found a sale without a sqft. Sale ID: ", v.id)
						}
					})
					let avgPrice = grossPrice / grossSales
					let avgSqft = grossSqft / grossSqftCount
					let avgPPSQFT = avgPrice / avgSqft
					let name = groupFind ? `${type.name} ${builder.name}` : builder.name
					let ele = echoRow({
						builder: name,
						bs: bs.length,
						bc: bc.length,
						net,
						avgPrice,
						avgSqft,
						avgPPSQFT,
					})
					let excelRow = {
						"Lot Type": type?.name,
						Builder: name,
						"Gross Sales": bs.length,
						"Net Sales": net,
						"Average Price": numeral(avgPrice).format("$0,0"),
						"Average Square Feet": numeral(avgSqft).format("0,0"),
						"Average Price Per Square Feet": numeral(avgPPSQFT).format("$0,0"),
						Cancels: bc.length,
					}
					if (!groupFind) {
						dataBox.push(ele)
						final.data.push(excelRow)
					} else {
						_.set(groupStore, `${groupFind.name}.${type.name} ${builder.name}`, ele)
						groupDataStore.push(excelRow)
					}
				})

				if (hasData) {
					let avgPrice = groupPrice / groupSales
					let avgSqft = groupSqft / groupSqftCount
					let avgPPSQFT = avgPrice / avgSqft
					let typeTotal = echoTypeTotal({
						sales: typeSales.length,
						cancels: typeCancels.length,
						avgPrice,
						avgSqft,
						avgPPSQFT,
					})
					let ele = (
						<table className="w-full text-sm mb-3" key={`${type.name}table`}>
							{header}
							<tbody>
								{dataBox}
								{typeTotal}
							</tbody>
						</table>
					)
					let excelRow = {
						"Lot Type": `${type.name} Total`,
						Builder: "",
						"Gross Sales": typeSales.length,
						"Net Sales": typeSales.length - typeCancels.length,
						"Average Price": numeral(avgPrice).format("$0,0"),
						"Average Square Feet": numeral(avgSqft).format("0,0"),
						"Average Price Per Square Feet": numeral(avgPPSQFT).format("$0,0"),
						Cancels: typeCancels.length,
					}
					if (!groupFind) {
						ret.push(ele)
						final.data.push(excelRow)
					} else {
						if (!_.has(groupTypeStore, groupFind.name)) {
							_.set(groupTypeStore, groupFind.name, {
								sales: typeSales.length,
								cancels: typeCancels.length,
								groupPrice,
								groupSales,
								groupSqft,
								groupSqftCount,
							})
						} else {
							groupTypeStore[groupFind.name].sales += typeSales.length
							groupTypeStore[groupFind.name].cancels += typeCancels.length
							groupTypeStore[groupFind.name].groupPrice += groupPrice
							groupTypeStore[groupFind.name].groupSales += groupSales
							groupTypeStore[groupFind.name].groupSqft += groupSqft
							groupTypeStore[groupFind.name].groupSqftCount += groupSqftCount
						}
					}
				}
			})
			// Now add the groups on
			_.forEach(groupStore, (r1, group) => {
				let header = echoHeader(group)

				let dataBox = []
				_.forEach(r1, (v, typeBuilder) => {
					dataBox.push(v)
				})
				// Figure out this groups totals
				let avgPrice = groupTypeStore[group].groupPrice / groupTypeStore[group].groupSales
				let avgSqft = groupTypeStore[group].groupSqft / groupTypeStore[group].groupSqftCount
				let avgPPSQFT = avgPrice / avgSqft
				let typeTotal = echoTypeTotal({
					sales: groupTypeStore[group].sales,
					cancels: groupTypeStore[group].cancels,
					avgPrice,
					avgSqft,
					avgPPSQFT,
				})
				let excelRow = {
					"Lot Type": `${group} Total`,
					Builder: "",
					"Gross Sales": groupTypeStore[group].sales,
					"Net Sales": groupTypeStore[group].sales - groupTypeStore[group].cancels,
					"Average Price": numeral(avgPrice).format("$0,0"),
					"Average Square Feet": numeral(avgSqft).format("0,0"),
					"Average Price Per Square Feet": numeral(avgPPSQFT).format("0,0"),
					Cancels: groupTypeStore[group].cancels,
				}
				groupDataStore.push(excelRow)
				ret.push(
					<table className="w-full text-sm mb-3" key={`grouptable${group}`}>
						{header}
						<tbody>
							{dataBox}
							{typeTotal}
						</tbody>
					</table>
				)
			})
			final.data = [...final.data, ...groupDataStore]
			// Grand total line
			let avgPrice = totalActualPrice / totalActualCount
			let avgSqft = totalActualSqft / totalActualSqftCount
			let avgPPSQFT = numeral(avgPrice / avgSqft).format("$0,0")
			ret.push(
				<table className="w-full text-sm mb-3" key={`grouptablegrandtotals`}>
					<tbody>
						<tr className="">
							<th className="w-[15%] text-left py-2 border-t-[1px] border-t-gray-300">Total</th>
							<th className="w-[10%] text-left py-2  border-t-[1px] border-t-gray-300">
								{numeral(totalCount).format("0,0")}
							</th>
							<th className="w-[10%] text-left py-2  border-t-[1px] border-t-gray-300">{totalCancels}</th>
							<th className="w-[10%] text-left py-2  border-t-[1px] border-t-gray-300">
								{totalCount - totalCancels}
							</th>
							<th className="w-[20%] text-left py-2  border-t-[1px] border-t-gray-300">
								{numeral(avgPrice).format("$0,0")}
							</th>
							<th className="w-[15%] text-left py-2  border-t-[1px] border-t-gray-300">
								{numeral(avgSqft).format("0,0")}
							</th>
							<th className="w-[20%] text-left py-2  border-t-[1px] border-t-gray-300">
								{numeral(avgPPSQFT).format("0,0")}
							</th>
						</tr>
					</tbody>
				</table>
			)
			final.data.push({
				"Lot Type": ``,
				Builder: "",
				"Gross Sales": totalCount,
				"Net Sales": totalCount - totalCancels,
				"Average Price": numeral(avgPrice).format("$0,0"),
				"Average Square Feet": numeral(avgSqft).format("0,0"),
				"Average Price Per Square Feet": avgPPSQFT,
				Cancels: totalCancels,
			})
			final.html = ret
			return final
		} catch (e) {
			console.log(e)
		}
	}

	ytdAvgSalePrice = (state, props, type) => {
		// type is island or internal
		let f = {
			html: null,
			data: [],
		}
		let datasets = []
		let labels = []
		let store = []
		let opts = {
			tooltips: {
				enabled: true,
				callbacks: {
					label: function (v) {
						return numeral(v.value).format("0,0")
					},
				},
			},
			legend: {
				display: false,
			},
			scales: {
				xAxes: [
					{
						ticks: {
							//beginAtZero: true,
						},
					},
				],
			},
			plugins: {
				datalabels: { display: false },
			},
		}
		try {
			let set = props.payload.salesTotalsByWeek.totals
			let year = type === "island" ? state.reportYear : state.selectedYear
			if (!_.get(set, year)) {
				return ""
			}
			_.forEach(set[year], (v, week) => {
				let total = parseInt(v.grossPrice / v.grossCount) || 0
				labels.push(week)
				store.push(total)
				f.data.push({
					Week: week,
					"Average Price": numeral(total).format("$0,0"),
				})
			})
			datasets.push({
				label: "Average Sale Price",
				data: store,
				borderColor: colorArray[0],
				backgroundColor: colorArray[0],
				fill: false,
			})
			const data = {
				labels,
				datasets,
			}
			f.html = <Line data={data} options={opts} />

			return f
		} catch (e) {
			console.log(e)
		}
	}

	buildClosingsTable = (state, props) => {
		var ret = []
		let set = state.closings
		for (let r of set) {
			var v = {}
			let builder = ""
			let findBuilder = _.find(props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}
			let type
			let typeFind = _.find(props.payload.public.lot_types, { id: r.lot_type })
			if (typeFind) {
				type = typeFind.name
			}
			let section
			let sectionFind = _.find(props.payload.public.sections, { id: r.section_id })
			if (sectionFind) {
				section = sectionFind.name
			}
			let diff = moment.unix(r.closing_date).diff(moment.unix(r.sale_date), "days")
			if (_.get(settings, `weekly.closingsDaysToClose`)) v.days_to_close = diff
			v.address = r.address
			v.builder = builder
			v.closing_date = r.closing_date
			v.date = r.sale_date ? r.sale_date : r.addedDate
			v.lot_type = type
			v.section = section

			let weeklys = this.weeklyDevExtraCalcs(r)
			if (settings.weeklyDevUserVisibility) v = { ...v, ...weeklys }
			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return ret
	}

	buildStartsTable = (state, props) => {
		var ret = []
		let set = state.starts
		for (let r of set) {
			var v = {}
			let builder = ""
			let findBuilder = _.find(props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}
			let type
			let typeFind = _.find(props.payload.public.lot_types, { id: r.lot_type })
			if (typeFind) {
				type = typeFind.name
			}
			let section
			let sectionFind = _.find(props.payload.public.sections, { id: r.section_id })
			if (sectionFind) {
				section = sectionFind.name
			}

			v.address = r.address
			v.builder = builder
			v.lot_type = type
			v.start_date = r.start_date
			v.sale_date = r.sale_date
			v.price = r.price ? `$${r.price.toLocaleString()}` : ""
			v.section = section
			v.sqft = r.sqft

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return ret
	}

	buildAveragesTable = (state, props) => {
		// This is gross per SRR
		var ret = []
		let set = state.sales
		let store = {}
		for (let r of set) {
			if (r.transfer_date) {
				continue
			}
			let builder = ""
			let findBuilder = _.find(props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
				builder = builder.replace(/[^\w- ]+/g, "")
			} else continue
			let type
			let typeFind = _.find(props.payload.public.lot_types, { id: r.lot_type })
			if (typeFind) {
				type = typeFind.name
			} else continue

			let path = `${builder}.${type}`
			let model = {
				total: 0,
				totalPrice: 0,
			}
			if (!_.has(store, path)) {
				_.setWith(store, path, model, Object)
			}
			store[builder][type].total++
			store[builder][type].totalPrice += r.price
		}
		_.forEach(store, (v1, builder) => {
			_.forEach(v1, (v2, type) => {
				ret.push({
					builder,
					lot_type: type,
					number: v2.total,
					average: v2.totalPrice / v2.total,
					totalPrice: v2.totalPrice,
				})
			})
		})
		//ret = _.sortBy(ret, "date").reverse()

		return ret
	}

	dirtVsSpec = (state, props) => {
		let dirt = 0
		let spec = 0
		_.forEach(state.sales, (v) => {
			if (v.transfer_date || v.bustout_date || v.cancel_date) {
				return
			}
			if (v.start_date && v.start_date <= v.sale_date) {
				spec++
			} else {
				dirt++
			}
		})

		const data = {
			labels: ["Breakout"],
			datasets: [
				{
					label: "Dirt",
					backgroundColor: "#3295EC",
					borderColor: "#3295EC",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: [dirt],
				},
				{
					label: "Spec",
					backgroundColor: "#ee7883",
					borderColor: "#ee7883",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: [spec],
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: {
					clamp: true,
				},
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	lotTypeBuilderBar = (state, props) => {
		const buildHomeSalesChartData = () => {
			let store = {}
			let years = []
			// Get years based on selected date range
			_.forEach(state.sales, (v) => {
				let year = moment.unix(v.sale_date).format("YYYY")
				years.push(year)
			})
			years = _.uniq(years)
			years = _.orderBy(years)

			_.forEach(state.sales, (v) => {
				let year = moment.unix(v.sale_date).format("YYYY")
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
				if (!builder || !type) {
					return
				}
				// Remove periods from names
				builder.name = builder.name.replace(/[^\w- ]+/g, "")
				// Need to ensure this combination is on every year
				_.forEach(years, (year) => {
					let path = `["${year}"].${type.name} - ${builder.name}`
					if (!_.has(store, path)) {
						_.setWith(store, path, { gross: 0, cancels: 0 }, Object)
					}
				})
				store[year][`${type.name} - ${builder.name}`].gross++
			})
			_.forEach(state.bustouts, (v) => {
				let year = moment.unix(v.bustout_date).format("YYYY")
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
				if (!builder || !type) {
					return
				}
				// Need to ensure this combination is on every year
				_.forEach(years, (year) => {
					let path = `["${year}"].${type.name} - ${builder.name}.cancels`
					if (!_.has(store, path)) {
						_.setWith(store, path, { gross: 0, cancels: 0 }, Object)
					}
				})
				store[year][`${type.name} - ${builder.name}`].cancels++
			})
			return store
		}
		let data = buildHomeSalesChartData()
		//console.log(data)
		let store = []
		_.forEach(data, (yearRow, year) => {
			let yearArray = []
			_.forEach(yearRow, (values, lotType) => {
				yearArray.push({
					name: lotType,
					values,
				})
			})
			yearArray = _.sortBy(yearArray, "name")
			store.push({
				year,
				data: yearArray,
			})
		})
		let datasets = []
		let labels = store[0] ? _.map(store[0].data, (v) => v.name) : []
		_.forEach(store, (v) => {
			let gross = _.map(v.data, (r) => r.values.gross - r.values.cancels)
			datasets.push({
				label: `${v.year} Net Sales`,
				backgroundColor: "#4ae09a",
				stack: v.year,
				data: gross,
			})
			let cancels = _.map(v.data, (r) => r.values.cancels)
			datasets.push({
				label: `${v.year} Cancels`,
				backgroundColor: "#EE7783",
				stack: v.year,
				data: cancels,
			})
		})
		let chartData = {
			labels,
			datasets,
		}
		const opts = {
			legend: {
				display: false,
				position: "bottom",
			},
			scales: {
				yAxes: [
					{
						scaleLabel: {
							display: true,
							labelString: "Gross Sales",
						},
					},
				],
			},
			plugins: {},
		}
		return (
			<div id="chart">
				<Bar data={chartData} options={opts} /* plugins={[totalizer]} */ />
			</div>
		)
	}

	yearOverYearChart = (state, props) => {
		// internal feeds off exec payload, island feeds off server response
		let property = state.property?.id || props?.activeProperties?.[0]
		// Showing 5 past years YoY net sales (originally HH)
		let months = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		]
		let activeYears = []
		for (let i = moment().year() - 5; i <= moment().year(); i++) {
			activeYears.push(i)
		}
		let store = {}
		if (!state.island) {
			_.forEach(activeYears, (v) => {
				_.forEach(months, (m) => {
					_.setWith(store, `${v}.${m}`, 0, Object)
				})
			})
			_.forEach(props.payload.exec.sales, (v) => {
				if (v.property !== property) {
					return
				}
				let saleYear = moment.unix(v.sale_date).year()
				let saleMonth = moment.unix(v.sale_date).format("MMMM")
				if (activeYears.includes(saleYear)) {
					store[saleYear][saleMonth]++
				}
			})
			_.forEach(props.payload.exec.busts, (v) => {
				if (v.property !== property) {
					return
				}
				let saleYear = moment.unix(v.bustout_date).year()
				let saleMonth = moment.unix(v.bustout_date).format("MMMM")
				if (activeYears.includes(saleYear)) {
					store[saleYear][saleMonth]--
				}
			})
		} else {
			store = props.payload.sales.fiveYearChart
		}
		let i = 0
		let datasets = _.map(activeYears, (v) => {
			i++
			let arr = _.map(months, (m) => {
				return store[v][m]
			})
			return {
				label: v,
				backgroundColor: colorArray[i],
				borderColor: colorArray[i],
				borderWidth: 1,
				hoverBackgroundColor: "rgba(50,149,236,0.5)",
				hoverBorderColor: "rgba(50,149,236,0.9)",
				data: arr,
			}
		})
		let data = {
			labels: months,
			datasets,
		}
		let opts = _.clone(lineOptions)
		opts.scales = {
			xAxes: [
				{
					//stacked: true,
				},
			],
			yAxes: [
				{
					//stacked: true,
				},
			],
		}
		opts.plugins = {
			datalabels: {},
		}
		return (
			<div style={{ marginBottom: 70 }}>
				<h2>Previous 5 Years Net Sales</h2>
				<Bar data={data} options={opts} />
			</div>
		)
	}

	salesBreakoutTable = (state, props) => {
		// opts added for neighborhood breakout - ember wants neighborhood due to highlands.
		let ret = []
		let property = state?.property?.id
		let store = {}
		//? Sales
		let model = {
			gross: 0,
			cancels: 0,
			closings: 0,
			specs: 0,
			net: 0,
		}
		if (settings?.weekly?.salesBreakoutNeighborhoods) {
			// lt -> neighborhood -> section -> builder
			//? Build the shell first
			let lts = _.filter(props.payload.public.lot_types, { property })
			let sections = _.filter(props.payload.public.sections, { property })
			let neighs = _.filter(props.payload.public.neighborhoods, { property })
			let builders = _.filter(props.payload.public.builders, (r) => {
				if (r.properties?.includes(property)) return r
			})
			_.forEach(lts, (lt) => {
				_.forEach(neighs, (n) => {
					_.forEach(sections, (s) => {
						// Check if this section has this lot type, else eject
						let check = s.lot_types[lt.id]
						if (!check) return
						// Also check if this section is in this neighborhood
						if (s.neighborhood !== n.id) {
							return
						}
						_.forEach(builders, (b) => {
							// Check if this builder is in this section
							let check = s.builders?.includes(b.id)
							if (!check) {
								return
							}
							b.name = helpers.safeBuilderName(b.name)
							let path = `${lt.name}.${n.name}.${s.name}.${b.name}`
							_.setWith(store, path, _.clone(model), Object)
						})
					})
				})
			})
			_.forEach(state.sales, (v) => {
				if (v.transfer_date) {
					return
				}
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
				let section = _.find(props.payload.public.sections, { id: v.section_id })
				let neigh = _.find(props.payload.public.neighborhoods, { id: section.neighborhood })
				if (!builder || !type || !section || !neigh) {
					return
				}
				builder.name = helpers.safeBuilderName(builder.name)
				let path = `${type.name}.${neigh.name}.${section.name}.${builder.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[type.name][neigh.name][section.name][builder.name].gross++
			})
			//? Cancels
			_.forEach(state.bustouts, (v) => {
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
				let section = _.find(props.payload.public.sections, { id: v.section_id })
				let neigh = _.find(props.payload.public.neighborhoods, { id: section.neighborhood })
				if (!builder || !type || !section || !neigh) {
					return
				}
				builder.name = helpers.safeBuilderName(builder.name)
				let path = `${type.name}.${neigh.name}.${section.name}.${builder.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[type.name][neigh.name][section.name][builder.name].cancels++
			})
			//? Closings
			_.forEach(state.closings, (v) => {
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
				let section = _.find(props.payload.public.sections, { id: v.section_id })
				let neigh = _.find(props.payload.public.neighborhoods, { id: section.neighborhood })
				if (!builder || !type || !section || !neigh) {
					return
				}
				builder.name = helpers.safeBuilderName(builder.name)
				let path = `${type.name}.${neigh.name}.${section.name}.${builder.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[type.name][neigh.name][section.name][builder.name].closings++
			})
			//? Specs
			_.forEach(props.payload?.weekly?.specs, (v) => {
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
				let section = _.find(props.payload.public.sections, { id: v.section_id })
				let neigh = _.find(props.payload.public.neighborhoods, { id: section.neighborhood })
				if (!builder || !type || !section || !neigh) {
					return
				}
				builder.name = helpers.safeBuilderName(builder.name)
				let path = `${type.name}.${neigh.name}.${section.name}.${builder.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[type.name][neigh.name][section.name][builder.name].specs++
			})

			_.forEach(store, (lt, ltName) => {
				_.forEach(lt, (neigh, nName) => {
					_.forEach(neigh, (sec, secName) => {
						_.forEach(sec, (b, bName) => {
							let net = b.gross - b.cancels
							store[ltName][nName][secName][bName].net = net
							ret.push({
								lot_type: ltName,
								section: secName,
								neighborhood: nName,
								builder: bName,
								gross: b.gross,
								cancels: b.cancels,
								closings: b.closings,
								specs: b.specs,
								net,
							})
						})
					})
				})
			})
		} else {
			// just lt -> section -> builder
			//? Build the shell first
			let lts = _.filter(props.payload.public.lot_types, { property })
			let sections = _.filter(props.payload.public.sections, { property })
			let builders = _.filter(props.payload.public.builders, (r) => {
				if (r.properties?.includes(property)) return r
			})
			_.forEach(lts, (lt) => {
				_.forEach(sections, (s) => {
					// Check if this section has this lot type, else eject
					let check = s.lot_types[lt.id]
					if (!check) return
					_.forEach(builders, (b) => {
						// Check if this builder is in this section
						let check = s.builders?.includes(b.id)
						if (!check) {
							return
						}
						b.name = helpers.safeBuilderName(b.name)
						let path = `${lt.name}.${s.name}.${b.name}`
						_.setWith(store, path, _.clone(model), Object)
					})
				})
			})
			_.forEach(state.sales, (v) => {
				if (v.transfer_date) {
					return
				}
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
				let section = _.find(props.payload.public.sections, { id: v.section_id })
				if (!builder || !type || !section) {
					return
				}
				builder.name = helpers.safeBuilderName(builder.name)
				let path = `${type.name}.${section.name}.${builder.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[type.name][section.name][builder.name].gross++
			})
			//? Cancels
			_.forEach(state.bustouts, (v) => {
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
				let section = _.find(props.payload.public.sections, { id: v.section_id })
				if (!builder || !type || !section) {
					return
				}
				builder.name = helpers.safeBuilderName(builder.name)
				let path = `${type.name}.${section.name}.${builder.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[type.name][section.name][builder.name].cancels++
			})
			//? Closings
			_.forEach(state.closings, (v) => {
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
				let section = _.find(props.payload.public.sections, { id: v.section_id })
				if (!builder || !type || !section) {
					return
				}
				builder.name = helpers.safeBuilderName(builder.name)
				let path = `${type.name}.${section.name}.${builder.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[type.name][section.name][builder.name].closings++
			})
			//? Specs
			_.forEach(props.payload?.weekly?.specs, (v) => {
				let builder = _.find(props.payload.public.builders, { id: v.builder })
				let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
				let section = _.find(props.payload.public.sections, { id: v.section_id })
				if (!builder || !type || !section) {
					return
				}
				builder.name = helpers.safeBuilderName(builder.name)
				let path = `${type.name}.${section.name}.${builder.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[type.name][section.name][builder.name].specs++
			})

			_.forEach(store, (lt, ltName) => {
				_.forEach(lt, (sec, secName) => {
					_.forEach(sec, (b, bName) => {
						let net = b.gross - b.cancels
						store[ltName][secName][bName].net = net
						ret.push({
							lot_type: ltName,
							section: secName,
							builder: bName,
							gross: b.gross,
							cancels: b.cancels,
							closings: b.closings,
							specs: b.specs,
							net,
						})
					})
				})
			})
		}
		let flushed = []
		// Remove rows that are all 0's
		_.forEach(ret, (v) => {
			if (v.cancels + v.closings + v.gross + v.net + v.specs !== 0) {
				flushed.push(v)
			}
		})
		return flushed
	}

	trafficBreakoutTable = (state, props) => {
		if (state.active === "life") return [] // Right now Life isn't in the payload as it's a lot.  If it comes up we'll need to add it.
		let ret = []
		let store = {}
		let property = state?.property?.id
		//? Build the shell first
		let lts = _.filter(props.payload.public.lot_types, { property: state.property?.id })
		let builders = _.filter(props.payload.public.builders, (r) => {
			if (r.properties?.includes(state.property?.id)) return r
		})
		let model = {}
		_.forEach(props.payload.public.trafficSources, (v) => {
			model[v.name] = 0
		})
		model.total = 0
		model["No Source"] = 0
		_.forEach(lts, (lt) => {
			_.forEach(builders, (b) => {
				let check = b.lot_types?.[property]?.includes(lt.id)
				if (!check) return
				b.name = helpers.safeBuilderName(b.name)
				let path = `${lt.name}.${b.name}`
				_.setWith(store, path, _.clone(model), Object)
			})
		})
		//? now build the data
		let bucket = state.island ? state?.trafficArray : props.payload.exec.weeklyReport.trafficEntries.ytd
		_.forEach(bucket?.grouped, (v) => {
			if (state.active === "week") {
				if (v.traffic_date <= state.startWeek || v.traffic_date >= state.endWeek) return
			} else if (state.active === "ytd") {
				if (v.traffic_date <= state.startYear || v.traffic_date >= state.endWeek) return
			}
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			let source = _.find(props.payload.public.trafficSources, { id: v.source })
			if (!builder || !type) {
				return
			}
			builder.name = helpers.safeBuilderName(builder.name)
			let path = `${type.name}.${builder.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			store[type.name][builder.name].total += v.prospect_count + v.realtor_count
			if (!source) {
				store[type.name][builder.name]["No Source"] += v.prospect_count + v.realtor_count
				return
			}
			store[type.name][builder.name][source.name] += v.prospect_count + v.realtor_count
		})
		_.forEach(bucket?.individual, (v) => {
			if (state.active === "week") {
				if (v.traffic_date <= state.times.startWeek || v.traffic_date >= state.times.endWeek) return
			} else if (state.active === "ytd") {
				if (v.traffic_date <= state.startYear || v.traffic_date >= state.times.endWeek) return
			}
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
			let source = _.find(props.payload.public.trafficSources, { id: v.source })
			if (!builder || !type) {
				return
			}
			builder.name = helpers.safeBuilderName(builder.name)
			let path = `${type.name}.${builder.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			store[type.name][builder.name].total++
			if (!source) {
				store[type.name][builder.name]["No Source"]++
				return
			}
			store[type.name][builder.name][source.name]++
		})
		_.forEach(store, (lt, ltName) => {
			_.forEach(lt, (b, bName) => {
				ret.push({
					lot_type: ltName,
					builder: bName,
					...b,
				})
			})
		})
		return ret
	}

	trafficBreakoutColumns = (state, props) => {
		let ret = [
			{
				Header: "Lot Type",
				accessor: "lot_type",
				filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
		]
		_.forEach(props.payload.public.trafficSources, (v) => {
			ret.push({
				Header: v.name,
				accessor: v.name,
				Footer: (props) => helpers.tableTotals(props, v.name, "0,0"),
			})
		})
		ret.push({
			Header: "Total",
			accessor: "total",
			Footer: (props) => helpers.tableTotals(props, "total", "0,0"),
		})
		return ret
	}

	summaryCustomModules = (state, props) => {
		// Specifically for the summary page, allows custom modules to be added above sales table.
		if (settings?.weekly?.summaryCustomModules) {
			const componentMap = {
				SalesAndConstruction,
				UnderContract,
				HomesClosedPTD,
				CompletedInventory,
				YoYStats,
				AveragePriceLotType,
				InventoryByBuilder,
			}
			let ret = []
			_.forEach(settings.weekly.summaryCustomModules, (v) => {
				const Component = componentMap[v]
				ret.push(<Component key={v} state={state} props={props} />)
			})
			return ret
		}
		return null
	}
}

export default WeeklyReportMethods
